import type { SiteTexts } from '@cmp/shared';
import { EN_TEXTS } from '@cmp/shared';

const DE: SiteTexts = {
  title: 'Wir verwenden Cookies',
  description: 'Wir verwenden Cookies, um diese Website zu betreiben. Mit Ihrer Erlaubnis messen wir auch Zugriffe und zeigen relevante Inhalte.',
  acceptAll: 'Alle akzeptieren',
  rejectAll: 'Alle ablehnen',
  settings: 'Einstellungen',
  save: 'Auswahl speichern',
  manage: 'Cookie-Einstellungen',
  privacyChoices: 'Ihre Datenschutzoptionen',
  gpcHonored: 'Opt-out-Anfrage berücksichtigt',
  privacyPolicy: 'Datenschutzerklärung',
  cookieDeclaration: 'Cookie-Erklärung',
  always: 'Immer aktiv',
  blockedEmbed: 'Dieser Inhalt wird erst nach Zustimmung zu Marketing-Cookies geladen.',
  loadEmbed: 'Inhalt laden',
  notice: 'Wir verwenden Cookies, um diese Website zu betreiben und Besuche anonym zu zählen.',
  object: 'Widersprechen',
  doNotSell: 'Meine Daten nicht verkaufen oder weitergeben',
  poweredBy: 'Bereitgestellt von',
  categories: {
    necessary: { name: 'Notwendig', description: 'Erforderlich für den Betrieb der Website. Kann nicht deaktiviert werden.' },
    functionality: { name: 'Präferenzen', description: 'Speichert Einstellungen wie Sprache oder Region.' },
    analytics: { name: 'Statistik', description: 'Hilft uns zu verstehen, wie die Website genutzt wird.' },
    marketing: { name: 'Marketing', description: 'Für relevante Werbung und Kampagnenmessung.' },
  },
};

const FR: SiteTexts = {
  title: 'Nous utilisons des cookies',
  description: 'Nous utilisons des cookies pour faire fonctionner ce site. Avec votre accord, nous mesurons aussi l’audience et affichons des contenus pertinents.',
  acceptAll: 'Tout accepter',
  rejectAll: 'Tout refuser',
  settings: 'Paramètres',
  save: 'Enregistrer',
  manage: 'Paramètres des cookies',
  privacyChoices: 'Vos choix de confidentialité',
  gpcHonored: "Demande d'opposition prise en compte",
  privacyPolicy: 'Politique de confidentialité',
  cookieDeclaration: 'Déclaration relative aux cookies',
  always: 'Toujours actif',
  blockedEmbed: 'Ce contenu est bloqué tant que vous n’acceptez pas les cookies marketing.',
  loadEmbed: 'Charger le contenu',
  notice: 'Nous utilisons des cookies pour faire fonctionner ce site et compter les visites de façon anonyme.',
  object: 'S’opposer',
  doNotSell: 'Ne pas vendre ni partager mes informations personnelles',
  poweredBy: 'Propulsé par',
  categories: {
    necessary: { name: 'Nécessaires', description: 'Indispensables au fonctionnement du site. Ne peuvent pas être désactivés.' },
    functionality: { name: 'Préférences', description: 'Mémorisent vos choix comme la langue ou la région.' },
    analytics: { name: 'Statistiques', description: 'Nous aident à comprendre l’utilisation du site.' },
    marketing: { name: 'Marketing', description: 'Servent à afficher des publicités pertinentes et mesurer les campagnes.' },
  },
};

const ES: SiteTexts = {
  title: 'Usamos cookies',
  description:
    'Usamos cookies para que este sitio funcione y, con tu consentimiento, para medir el tráfico y personalizar el contenido. Puedes cambiar tu elección en cualquier momento.',
  acceptAll: 'Aceptar todo',
  rejectAll: 'Rechazar todo',
  settings: 'Configuración',
  save: 'Guardar',
  manage: 'Configuración de cookies',
  privacyChoices: 'Tus opciones de privacidad',
  gpcHonored: 'Solicitud de exclusión atendida',
  privacyPolicy: 'Política de privacidad',
  cookieDeclaration: 'Declaración de cookies',
  always: 'Siempre activo',
  blockedEmbed: 'Este contenido está bloqueado hasta que aceptes las cookies de marketing.',
  loadEmbed: 'Cargar contenido',
  notice: 'Usamos cookies para que este sitio funcione y contar las visitas de forma anónima.',
  object: 'Oponerse',
  doNotSell: 'No vender ni compartir mi información personal',
  poweredBy: 'Con tecnología de',
  categories: {
    necessary: { name: 'Necesarias', description: 'Imprescindibles para que el sitio funcione. No se pueden desactivar.' },
    functionality: { name: 'Preferencias', description: 'Recuerdan opciones como el idioma o la región.' },
    analytics: { name: 'Estadísticas', description: 'Nos ayudan a entender cómo se usa el sitio.' },
    marketing: { name: 'Marketing', description: 'Para mostrar anuncios relevantes y medir campañas.' },
  },
};

const IT: SiteTexts = {
  title: 'Utilizziamo i cookie',
  description:
    'Utilizziamo i cookie per far funzionare questo sito e, con il tuo consenso, per misurare il traffico e personalizzare i contenuti. Puoi cambiare la tua scelta in qualsiasi momento.',
  acceptAll: 'Accetta tutto',
  rejectAll: 'Rifiuta tutto',
  settings: 'Impostazioni',
  save: 'Salva',
  manage: 'Impostazioni cookie',
  privacyChoices: 'Le tue scelte sulla privacy',
  gpcHonored: 'Richiesta di opposizione rispettata',
  privacyPolicy: 'Informativa sulla privacy',
  cookieDeclaration: 'Dichiarazione sui cookie',
  always: 'Sempre attivo',
  blockedEmbed: 'Questo contenuto è bloccato finché non accetti i cookie di marketing.',
  loadEmbed: 'Carica contenuto',
  notice: 'Usiamo i cookie per far funzionare questo sito e contare le visite in forma anonima.',
  object: 'Opponiti',
  doNotSell: 'Non vendere né condividere i miei dati personali',
  poweredBy: 'Realizzato con',
  categories: {
    necessary: { name: 'Necessari', description: 'Indispensabili per il funzionamento del sito. Non possono essere disattivati.' },
    functionality: { name: 'Preferenze', description: 'Ricordano scelte come lingua o regione.' },
    analytics: { name: 'Statistiche', description: 'Ci aiutano a capire come viene usato il sito.' },
    marketing: { name: 'Marketing', description: 'Per mostrare annunci pertinenti e misurare le campagne.' },
  },
};

const NL: SiteTexts = {
  title: 'Wij gebruiken cookies',
  description:
    'Wij gebruiken cookies om deze site te laten werken en, met uw toestemming, om bezoek te meten en inhoud te personaliseren. U kunt uw keuze op elk moment wijzigen.',
  acceptAll: 'Alles accepteren',
  rejectAll: 'Alles weigeren',
  settings: 'Instellingen',
  save: 'Keuze opslaan',
  manage: 'Cookie-instellingen',
  privacyChoices: 'Uw privacykeuzes',
  gpcHonored: 'Bezwaarverzoek gehonoreerd',
  privacyPolicy: 'Privacybeleid',
  cookieDeclaration: 'Cookieverklaring',
  always: 'Altijd aan',
  blockedEmbed: 'Deze inhoud is geblokkeerd totdat u marketingcookies accepteert.',
  loadEmbed: 'Inhoud laden',
  notice: 'We gebruiken cookies om deze site te laten werken en bezoeken anoniem te tellen.',
  object: 'Bezwaar maken',
  doNotSell: 'Mijn persoonsgegevens niet verkopen of delen',
  poweredBy: 'Mogelijk gemaakt door',
  categories: {
    necessary: { name: 'Noodzakelijk', description: 'Nodig om de site te laten werken. Kan niet worden uitgeschakeld.' },
    functionality: { name: 'Voorkeuren', description: 'Onthouden keuzes zoals taal of regio.' },
    analytics: { name: 'Statistieken', description: 'Helpen ons te begrijpen hoe de site wordt gebruikt.' },
    marketing: { name: 'Marketing', description: 'Voor relevante advertenties en het meten van campagnes.' },
  },
};

export const BUILTIN_TEXTS: Record<string, SiteTexts> = { en: EN_TEXTS, de: DE, fr: FR, es: ES, it: IT, nl: NL };

/** Pick texts: site overrides first, then built-in, then English. */
export function pickTexts(site: Record<string, SiteTexts>, defaultLang: string): { lang: string; texts: SiteTexts } {
  const candidates: string[] = [];
  const docLang = document.documentElement.lang;
  if (docLang) candidates.push(docLang.toLowerCase(), docLang.slice(0, 2).toLowerCase());
  for (const l of navigator.languages || [navigator.language]) {
    if (l) candidates.push(l.toLowerCase(), l.slice(0, 2).toLowerCase());
  }
  candidates.push(defaultLang, 'en');
  for (const c of candidates) {
    // Site texts may predate newer keys; built-in strings fill the gaps.
    if (site[c]) return { lang: c, texts: { ...(BUILTIN_TEXTS[c] ?? EN_TEXTS), ...site[c]!, categories: { ...(BUILTIN_TEXTS[c] ?? EN_TEXTS).categories, ...site[c]!.categories } } };
    if (BUILTIN_TEXTS[c]) return { lang: c, texts: BUILTIN_TEXTS[c]! };
  }
  return { lang: 'en', texts: EN_TEXTS };
}
